import Vue from 'vue';
import {
    mapActions,
    mapGetters
} from 'vuex';
import SearchBox from './../components/search-box/SearchBox.vue';
import LiveBanner from './../components/live-banner/LiveBanner.vue';
import CookiesBanner from './../components/cookies-banner/CookiesBanner.vue';
import epica from '../../features/epica';
import {
    helpers
} from '../../features/epica';

import store from '../store';
export const header = (mixins) => {
    helpers();
    mixins = mixins ? mixins : [{
        created() {
            this.userBasic();
        }
    }];
    const headerSelector = '#vue-header';
    window.vueHeader = new Vue({
        el: headerSelector,
        mixins: mixins,
        store,
        components: {
            SearchBox,
            CookiesBanner,
            LiveBanner
        },
        computed: {
            ...mapGetters('auth', {
                user: 'user',
                hasLoaded: 'hasLoaded'
            })
        },
        data: function () {
            return {
                isMenuShow: false,
                isHeaderFixed: window.scrollY > 200,
                isPlayingQuoteBanner: true,
                menuLrPlus: false,
                searchBoxIsOpen: false
            };
        },
        watch: {
            isMenuShow: function (newVal, oldVal) {
                if (newVal) {
                    document.body.classList.add("overflow-hidden");
                } else {
                    document.body.classList.remove("overflow-hidden");
                }
            },
            searchBoxIsOpen: function (newVal, oldVal) {
                if (newVal) {
                    document.body.classList.add("overflow-hidden");
                } else {
                    document.body.classList.remove("overflow-hidden");
                }
            }
        },
        created() {
            this.init();
            let last_known_scroll_position = 0;
            let ticking = false;
            const _self = this;
            window.addEventListener('scroll', function (e) {
                last_known_scroll_position = window.scrollY;
                if (!ticking) {
                    window.requestAnimationFrame(function () {
                        _self.handleScroll(last_known_scroll_position);
                        ticking = false;
                    });
                }
                ticking = true;
            });
        },
        mounted: function () {
            epica(headerSelector);
        },
        methods: {
            ...mapActions({
                login: 'auth/login',
                logout: 'auth/logout',
                init: 'auth/init',
                userBasic: 'auth/getUserBasic',
                userNews: 'auth/getUserNews',
            }),
            hideLRMenu: function () {
                document.body.removeEventListener('click', this.hideLRMenu);
                this.menuLrPlus = false;
            },
            showLRMenu: function () {
                this.menuLrPlus = true;
                document.body.addEventListener('click', this.hideLRMenu);
            },
            closeMenu: function () {
                this.isMenuShow = false;
            },
            showMenu: function () {
                this.isMenuShow = true;
            },
            handleScroll: function (scrollY) {
                this.isHeaderFixed = scrollY > 200;
            },
            stopQuoteBanner: function () {
                clearTimeout(qTimeoutId);
                const ll = ComputeLeft();
                const _firstList = document.querySelectorAll(".list-first")[0];
                const _secondList = document.querySelectorAll(".list-second")[0];
                _firstList.classList.remove("move-list-first");
                _secondList.classList.remove("move-list-second");
                _firstList.style.left = ll + "px";
                _secondList.style.left = ll + "px";
            },
            startQuoteBanner: function () {
                const ll = ComputeLeft();
                const _firstList = document.querySelectorAll(".list-first")[0];
                const _secondList = document.querySelectorAll(".list-second")[0];
                _firstList.classList.add("move-list-first");
                _secondList.classList.add("move-list-second");
                _firstList.style.left = ll + "px";
                _secondList.style.left = ll + "px";
                removeLeft(ll);
            },
            overQuoteBanner: function () {
                if (this.isPlayingQuoteBanner) {
                    this.stopQuoteBanner();
                }
            },
            leaveQuoteBanner: function () {
                if (this.isPlayingQuoteBanner) {
                    this.startQuoteBanner();
                }
            },
            toggleQuoteBanner: function () {
                this.isPlayingQuoteBanner = !this.isPlayingQuoteBanner;
                if (this.isPlayingQuoteBanner) {
                    this.startQuoteBanner();
                } else {
                    this.stopQuoteBanner();
                }
            },
        }
    });
}



let qTimeoutId = null;
const ComputeLeft = () => {
    const l1 = document.querySelectorAll(".list-first")[0].getBoundingClientRect().x - document.querySelectorAll(".quote-banner-container")[0].getBoundingClientRect().x;
    const l2 = document.querySelectorAll(".list-second")[0].getBoundingClientRect().x - document.querySelectorAll(".quote-banner-container")[0].getBoundingClientRect().x;
    return l1 < 0 && l2 < 0 ? (l1 < l2 ? l2 : l1) : (l1 > l2 ? l2 : l1);
}

const removeLeft = (ll) => {
    const _firstList = document.querySelectorAll(".list-first")[0];
    const _secondList = document.querySelectorAll(".list-second")[0];
    const x = _firstList.getBoundingClientRect().width;
    const seconds = (x + ll) / x * 50;
    qTimeoutId = setTimeout(function () {
        _firstList.classList.remove("move-list-first");
        _secondList.classList.remove("move-list-second");
        _firstList.style.left = null;
        _secondList.style.left = null;
        setTimeout(function () {
            _firstList.classList.add("move-list-first");
            _secondList.classList.add("move-list-second");
        }, 100);
    }, seconds * 1000)
}